import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css']
})
export class SearchInputComponent {
  @Input() placeholder: string = 'Search...';
  @Input() searchControl: FormControl = new FormControl();

  @Output() searchChange = new EventEmitter<string>();

  constructor() {
    this.searchControl.valueChanges.subscribe((value) => {
      this.searchChange.emit(value);
    });
  }
}
